import React from "react";
import { node, func } from "prop-types";
import context, { Provider } from "./context";

const RouterProvider = ({ routerPush, children }) => (
	<Provider value={routerPush}>{children}</Provider>
);

RouterProvider.context = context;

RouterProvider.propTypes = {
	routerPush: func,
	children: node,
};
export default RouterProvider;
